import { Input, validateInput, ValidationFunction } from "basis";

// See: https://en.wikipedia.org/wiki/Telephone_numbers_in_New_Zealand#Mobile_phones
const NZ_MOBILE_NUMBER_REGEX = /^\s*(\+\s*6\s*4|0)\s*2(\s*\d){7,9}\s*$/;

export const validateNzMobileNumber: ValidationFunction<typeof Input> = (
  value,
  props,
) => {
  const errors = validateInput(value, props);

  if (errors) {
    return errors;
  }

  if (NZ_MOBILE_NUMBER_REGEX.test(value) === false) {
    return "Invalid mobile number";
  }

  return null;
};

// See: https://en.wikipedia.org/wiki/Telephone_numbers_in_Australia#Mobile_phones
const AU_MOBILE_NUMBER_REGEX = /^\s*(\+\s*6\s*1|0)\s*[45](\s*\d){8}\s*$/;

export const validateAuMobileNumber: ValidationFunction<typeof Input> = (
  value,
  props,
) => {
  const errors = validateInput(value, props);

  if (errors) {
    return errors;
  }

  if (AU_MOBILE_NUMBER_REGEX.test(value) === false) {
    return "Invalid mobile number";
  }

  return null;
};

// Source: https://emailregex.com
const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const validateEmail: ValidationFunction<typeof Input> = (
  value,
  props,
) => {
  const errors = validateInput(value, props);

  if (errors) {
    return errors;
  }

  if (EMAIL_REGEX.test(value) === false) {
    return "Invalid email address";
  }

  return null;
};

export const validateEmailSameAs: (
  email: string,
  errorMsg: string,
) => ValidationFunction<typeof Input> = (email, errorMsg) => (value, props) => {
  const errors = validateEmail(value, props);

  if (errors) {
    return errors;
  }

  if (email.toLocaleLowerCase() !== value.toLocaleLowerCase()) {
    return errorMsg;
  }

  return null;
};

export const validateEmailDifferentFrom: (
  email: string,
  errorMsg: string,
) => ValidationFunction<typeof Input> = (email, errorMsg) => (value, props) => {
  const errors = validateEmail(value, props);

  if (errors) {
    return errors;
  }

  if (email.toLocaleLowerCase() === value.toLocaleLowerCase()) {
    return errorMsg;
  }

  return null;
};
